import { createRouter } from 'cell-router';

export const { Router, Route, Link } = createRouter();
